import { render, staticRenderFns } from "./BizOrder.vue?vue&type=template&id=25245e46&scoped=true&"
import script from "./BizOrder.vue?vue&type=script&lang=js&"
export * from "./BizOrder.vue?vue&type=script&lang=js&"
import style0 from "./BizOrder.vue?vue&type=style&index=0&id=25245e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25245e46",
  null
  
)

export default component.exports